module.exports = __webpack_public_path__ + "img/facebook-logo.98585487.svg";